import { useGetAllDealerAddressBrandAddrReportQuery, useCreateDealerAddressBrandAddrReportMutation, useUpdateDealerAddressBrandAddrReportMutation } from '../../../../../api';

import { useState, useEffect } from 'react';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { formatDateOnly } from '../../../../../utils/dateUtils';

export const useAddrReportData = ({ dealerAddressBrandId, dealer, dealerAddress, pageSize = 10, enabled = true }) => {
    const { th, getCurrentLanguageId } = useLanguage();

    const [pageNumber, setPageNumber] = useState(1);

    const safeDealer = dealer || { id: null, name: '' }; // ✅ Patlamaz

    const {
        data = { items: [], count: 0 },
        isLoading,
        isFetching,
        isError,
        error,
        refetch
    } = useGetAllDealerAddressBrandAddrReportQuery(
        {
            dealerAddressBrandId,
            pageNumber,
            pageSize,
            languageId: getCurrentLanguageId()
        },
        { skip: !enabled }
    );

    const [createAddrReport] = useCreateDealerAddressBrandAddrReportMutation();
    const [updateAddrReport] = useUpdateDealerAddressBrandAddrReportMutation();

    // ✅ Kolon aynı
    const columns = [
        {
            field: 'selectTypeText',
            sortField: 'selectType',
            header: th('customerAddressBrand.tabs.addrReport.columns.selectTypeText'),
            body: (rowData) => rowData.selectTypeText ?? '-'
        },
        { field: 'dealerName', header: th('customerAddressBrand.tabs.addrReport.columns.dealerName') },
        { field: 'dealerAddrName', header: th('customerAddressBrand.tabs.addrReport.columns.dealerAddrName') },
        { field: 'interserviceName', header: th('customerAddressBrand.tabs.addrReport.columns.interserviceName') },
        { field: 'interserviceAddrName', header: th('customerAddressBrand.tabs.addrReport.columns.interserviceAddrName') },
        {
            field: 'laborPriceDiff',
            header: th('customerAddressBrand.tabs.addrReport.columns.laborPriceDiff'),
            body: (rowData) => (rowData.laborPriceDiff !== null && rowData.laborPriceDiff !== undefined ? rowData.laborPriceDiff.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) : '-')
        },
        { field: 'createdName', header: th('customerAddressBrand.tabs.addrReport.columns.createdName') },
        {
            field: 'createdDate',
            header: th('customerAddressBrand.tabs.addrReport.columns.createdDate'),
            body: (rowData) => formatDateOnly(rowData.createdDate) || '-'
        }
    ];

    // ✅ API’den gelen item’ları dealer parametresiyle overwrite et
    const items = (data.items || []).map((item) => ({
        ...item,
        dealerId: safeDealer.id, // Sabit değer
        dealerName: safeDealer.name,

        // Servis name
        interserviceName: item.interserviceDealerFullName,
        // Servis adres name
        interserviceAddrName: item.interserviceDealerAddressName,

        // Bayi adres name
        dealerAddrName: item.dealerAddressName,
        branchSiteAdr: item.branchSiteAdr,
        laborPriceDiff: item.laborPriceDiff ?? null //
    }));

    const save = async (formData) => {
        try {
            if (formData.id) {
                const payload = {
                    id: formData.id,
                    dealerId: Number(dealer.id) || 0, // ✅ Hook parametresi
                    dealerAddressId: Number(dealerAddress.id) || 0,
                    dealerAddressBrandId,
                    interserviceId: Number(formData.interserviceId) || 0,
                    interserviceAddressId: Number(formData.interserviceAddressId) || 0,
                    erpSiteUseId: Number(formData.erpSiteUseId) || 0,
                    selectType: Number(formData.selectType) || 1,
                    laborPriceDiff: formData.selectType === 2 ? formData.laborPriceDiff : null
                };
                await updateAddrReport(payload).unwrap();
            } else {
                const payload = {
                    dealerId: Number(dealer.id) || 0, // ✅ Hook parametresi
                    dealerAddressId: Number(dealerAddress.id) || 0,
                    dealerAddressBrandId,
                    interserviceId: Number(formData.interserviceId) || 0,
                    interserviceAddressId: Number(formData.interserviceAddressId) || 0,
                    erpSiteUseId: Number(formData.erpSiteUseId) || 0,
                    selectType: Number(formData.selectType) || 1,
                    laborPriceDiff: formData.selectType === 2 ? formData.laborPriceDiff : null
                };
                await createAddrReport(payload).unwrap();
                console.log('✅ Addr Report oluşturuldu', payload);
            }
            refetch();
        } catch (err) {
            console.error('❌ Addr Report kayıt hatası:', err);
        }
    };

    return {
        items,
        count: data.count,
        isLoading: isLoading || isFetching,
        columns,
        save,
        refetch,
        pageNumber,
        setPageNumber,
        pageSize
    };
};
